import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'

export const routes = [
  {
    path: '/research-and-development',
    name: 'research-and-development',
    meta: {
      sitemap: {
        title: 'R&D funding',
        description: 'Research and Development tax incentives',
        conditions: {
          all: [
            { fact: 'additionalProducts', path: '$.enableResearchAndDevelopmentPage', operator: 'equal', value: true },
            { fact: 'global', path: '$.countryCode', operator: 'in', value: ['GB', 'US'] }
          ]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/ResearchAndDevelopment.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/business-savings-accounts',
    name: 'business-savings-accounts',
    meta: {
      description: 'Compare savings account options',
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/BusinessSavingsAccounts.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/foreign-exchange',
    name: 'foreign-exchange',
    meta: {
      sitemap: {
        title: 'Foreign exchange',
        description: 'FX services',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enableFXPage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/ForeignExchange.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/pension',
    name: 'pension',
    meta: {
      sitemap: {
        title: 'Pensions',
        description: 'Pension products and planning',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enablePensionPage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/Pension.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/business-insurance',
    name: 'business-insurance',
    meta: {
      sitemap: {
        title: 'Business insurance',
        description: 'Business insurance products',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enableBusinessInsurancePage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/BusinessInsurance.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/credit-score-improvements',
    name: 'credit-score-improvements',
    meta: {
      sitemap: {
        title: 'Credit score improvements',
        description: 'Tools to enhance credit score',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enableCreditScoreImprovementsPage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/CreditScoreImprovements.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/utilities',
    name: 'utilities',
    meta: {
      sitemap: {
        title: 'Energy savings',
        description: 'Find utility cost savings',
        conditions: {
          all: [
            { fact: 'portal', path: '$.enableSavingsFeatures', operator: 'equal', value: true },
            { fact: 'portal', path: '$.enableUtilitiesPage', operator: 'equal', value: true }
          ]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/Utilities.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },
  {
    path: '/business-checking-accounts',
    name: 'business-checking-accounts',
    meta: {
      sitemap: {
        title: 'Business checking accounts',
        description: 'Business checking account options',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enableBusinessCheckingAccountsPage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/BusinessCheckingAccounts.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  },

  {
    path: '/business-credit-cards',
    name: 'business-credit-cards',
    meta: {
      sitemap: {
        title: 'Business credit cards',
        description: 'Compare business credit card options (US, CA, AU)',
        conditions: {
          all: [
            { fact: 'global', path: '$.countryCode', operator: 'notEqual', value: 'GB' },
            { fact: 'additionalProducts', path: '$.enableCreditCardPage', operator: 'equal', value: true }
          ]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./pages/BusinessCreditCards.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
